import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/hooks/use-auth-compat';
import { getProfile } from '@/services/UserManagmentServices';

export function useCurrentUser() {
  const auth = useAuth();
  const token = auth.user?.access_token ?? sessionStorage.getItem('access_token') ?? '';

  const query = useQuery({
    queryKey: ['currentUser'],
    queryFn: () => getProfile(token),
    enabled: !!token,
    staleTime: 5 * 60 * 1000,
  });

  return {
    user: query.data ?? null,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
